/**
 * @generated SignedSource<<91de6469fa013ca9850e9ff4bcbac3d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutTabs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutItemPanel_viewer">;
  readonly " $fragmentType": "PdpRespAboutTabs_viewer";
};
export type PdpRespAboutTabs_viewer$key = {
  readonly " $data"?: PdpRespAboutTabs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutTabs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutTabs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutItemPanel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3548ab14f6beb6b7746bd8cfbfb5a0c6";

export default node;
